var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-intro"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"fixed-image"},[_c('div',{staticClass:"image-mask"},[_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.src}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c014716","hasScoped":true}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-intro.vue
// module id = 423
// module chunks = 0